import {createReducer, on} from "@ngrx/store";
import {CaseEntitiesActions} from "../actions";
import {CaseEntityDto} from "@esa/api/models/CaseEntityDto";
import {CaseStatusEnum} from "@esa/api";

export const caseEntitesFeatureKey = 'caseEntities';

export interface CaseEntitiesState {
  caseEntities: CaseEntityDto[];
  selectedCaseEntity: CaseEntityDto;
  selectedCaseEntityId: string;
  showEditForm: boolean;
}

const initialState: CaseEntitiesState = {
  caseEntities: [],
  selectedCaseEntity: {
    id: "",
    caseTitle: "",
    caseDescription: "",
    casePriority: null,
    dateCreated: "",
    lastUpdated: "",
    generatedCaseNumber: "",
    caseStatus: CaseStatusEnum.NEW,
    createdByUserId: "",
    originatingFiuId: "",
    assignedUserId: "",
    assignedFIUId: "",
    caseSubjects: [],
    caseDetails: []
  },
  selectedCaseEntityId: "",
  showEditForm: false
};

export const caseEntitiesReducer = createReducer(
  initialState,
  on(CaseEntitiesActions.getCaseEntitiesSuccess, (state, { caseEntities }) => ({ ...state, caseEntities })),
  on(CaseEntitiesActions.getCaseEntityByIdSuccess, (state, { selectedCaseEntity }) => ({ ...state, selectedCaseEntity })),
  on(CaseEntitiesActions.setSelectedCaseEntityId, (state, { selectedCaseEntityId }) => ({ ...state, selectedCaseEntityId,selectedCaseEntity: {
      id: "",
      caseTitle: "",
      caseDescription: "",
      casePriority: null,
      dateCreated: "",
      lastUpdated: "",
      generatedCaseNumber: "",
      caseStatus: CaseStatusEnum.NEW,
      createdByUserId: "",
      originatingFiuId: "",
      assignedUserId: "",
      assignedFIUId: "",
      caseSubjects: [],
      caseDetails: []
    } })),
  on(CaseEntitiesActions.createCaseEntitySuccess, (state, { showEditForm }) => ({ ...state, showEditForm })),
  on(CaseEntitiesActions.setShowEditForm, (state, { showEditForm }) => ({ ...state, showEditForm }))
);
